export default {
  topic_search_circle:'沒找到{keyword}相關的圈子',
}
